export default __webpack_public_path__ + "static/media/advanced.eab282a7.png";